import "./App.scss";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home/Home";
import MyGigs from "./pages/myGigs/MyGigs";
import Add from "./pages/add/Add";
import Orders from "./pages/orders/Orders";
import Messages from "./pages/messages/Messages";
import Message from "./pages/message/Message";
import Gigs from "./pages/gigs/Gigs";
import Gig from "./pages/gig/Gig";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";

import Pay from "./pages/pay/Pay";
import Success from "./pages/success/Success";
import Notification from "./components/Notification/Notification";
import { Layout, RequireAuth } from "./pages/layout/Layout";

function App() {
  // const queryClient = new QueryClient();
  // const Layout = () => {
  //   return (
  //     <div className="app">
  //       <QueryClientProvider client={queryClient}>
  //         <Navbar />
  //         <Outlet />
  //         <Footer />
  //       </QueryClientProvider>
  //     </div>
  //   );
  // };
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <Home />,
        },

        {
          path: "/gigs",
          element: <Gigs />,
        },

        {
          path: "/login",
          element: <Login />,
        },
        {
          path: "/Register",
          element: <Register />,
        },
      ],
    },
    {
      path: "/",
      element: <RequireAuth />,
      children: [
        {
          path: "/gig/:id",
          element: <Gig />,
        },
        {
          path: "/success",
          element: <Success />,
        },
        {
          path: "/pay/:id",
          element: <Pay />,
        },
        {
          path: "/messages",
          element: <Messages />,
        },
        {
          path: "/message/:id",
          element: <Message />,
        },
        {
          path: "/ordres",
          element: <Orders />,
        },
        {
          path: "/add",
          element: <Add />,
        },
        {
          path: "/mygigs",
          element: <MyGigs />,
        },
      ],
    },
  ]);
  return (
    <>
      <RouterProvider router={router} /> <Notification />
    </>
  );
}

export default App;
